import { Columns } from '@shared/interfaces/table/column-config';
import {ConnectionPointDto} from '@app/api/nts';
import { statePartial } from '@shared/partials/state.partial';
import { TranslateCellComponent } from '@shared/components/table/cells/translate-cell/translate-cell.component';

export const connectionpointDetailsMasterdata: Columns<ConnectionPointDto>[] = [
  {
    title: 'Tilslutningspunktnummer',
    key: 'identification'
  },
  {
    title: 'Alternativt tilslutningspunktnummer',
    key: 'alternativeIdentification'
  },
  {
    title: 'Stationsnummer',
    key: 'stationNumber'
  },
  statePartial,
  {
    title: 'Kategori',
    key: 'connectionPointCategory.name'
  },
  {
    title: 'connectionRight.owner',
    key: 'connectionPointOwnsConnectionRights',
    cellRenderer: TranslateCellComponent,
    cellRendererParams: {
      true: 'connectionRight.ownerConnectionPoint',
      false: 'connectionRight.ownerMeterFrame',
    },
  },
  {
    title: 'Beskrivelse',
    key: 'description'
  }
];
